export const language = {
    languageName: "한국어",

    app: {
        name: "LRC 메이커",
        fullname: "Akari의 LRC 메이커",
    },

    header: {
        home: "홈",
        editor: "편집기",
        synchronizer: "동기화",
        gist: "Github Gist",
        preferences: "설정",
    },

    audio: {
        loadAudio: "음원 로드하기",
        play: "재생",
        pause: "일시 중지",
        replay5s: "5초 뒤로 가기",
        forward5s: "5초 건더 뛰기",
        resetRate: "재생 속도 다시 설정",
        error: [
            "오디오 오류",
            "사용자가 오디오를 중단됨",
            "오디오 넷워크 오류",
            "오디오 디코딩 오류",
            "오디오 지원하지 앖습니다",
        ],
    },

    loadAudio: {
        file: "파일",
        url: "링크",
        loadFile: "여기로 파일 선택하기 또는 오디오 파일을 이 페이지에 드롭하기",
    },

    home: {
        tips: "팁",
        tipForLyricText: "편집기 페이지에 가사 텍스트를 붙여넣기.",
        tipForUploadAudio: "왼쪽 하단에는 버튼 클릭하면 오디오 파일 로드하기.",
        tipForSynchronizer: "동기화 페이기에 당신의 가사를 만드세요 :)",
        tipTopLeft: "에기에 클릭하면  이 페이지 돌아와세요",
        tipTopRight: "에기에 다른 페이지 탐색하세요",
        tipBottomLeft: "여기에 오리오를 로드하고 제어하세요",
        tipBottomRight: "여기에 재생 속도를 조정하세요",
    },

    editor: {
        metaInfo: "메타 정보",
        album: "앨범",
        title: "트랙 이름",
        artist: "아티스트",
        uploadText: "텍스트 업로드",
        copyText: "모두 선택 및 복사",
        downloadText: "다운로드",
        saveToGist: "GitHub Gist에 저장하기",
        saveFileName: "파일 이름",
        utils: "lrc 도구",
    },

    gist: {
        newTokenTip: "LRC 메이커는 GitHub 토큰으로 GitHub Gist 에서 데이터를 접근하고 저장합니다",
        newTokenButton: "새로운 GitHub 토큰 생성하기",
        newGistTip: "Create a new Gist repository or assign an existing Gist id",
        newGistRepoButton: "Create a new Gist Repository",
        gistIdPlaceholder: "Or assign an existing Gist id",
        info: "info",
        clearTokenAndGist: "Clear token and Gist id",
    },

    preferences: {
        version: "버전",
        commitHash: "토밋 헤시",
        updateTime: "업데이트 시간",
        repo: "저장고",
        help: "도움말 및 팁",
        language: "언어(language)",
        builtInAudio: "브라우저 빌트인 오디오 재생기 사용하기",
        spaceButton: "온 스크린 스페이스 키",
        themeColor: "모양색",
        lrcFormat: "LRC 포멧 조정",
        fixed: "타임 스템 고치됨",
        leftSpace: "왼쪽 스페이스",
        rightSpace: "오른쪽 스페이스",
        clearCache: "캐시 제거",
        themeMode: {
            label: "모양 모드",
            auto: "자동",
            light: "라이트",
            dark: "다크",
        },
    },

    notify: {
        audioLoaded: "음원 로드됨",
    },
};
